var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12 mt-2" }, [
      _c(
        "ul",
        { staticClass: "activities" },
        _vm._l(_vm.activities, function(item, index) {
          return _c(
            "li",
            { key: index },
            [
              _c("span", { domProps: { innerHTML: _vm._s(item.text) } }),
              _vm._v(" "),
              _c(
                "vs-tooltip",
                {
                  staticClass: "info-icon",
                  attrs: {
                    text: _vm.getDateTime(item.created_at),
                    position: "left"
                  }
                },
                [
                  _c("i", {
                    staticClass: "fas fa-info-circle",
                    staticStyle: { "font-size": "16px" }
                  })
                ]
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15a9b090", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15a9b090","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSectionDocRefActivity.vue
// module id = null
// module chunks = 